import { makeStyles } from '@mui/styles';

// Section layout: 1 column (xs/sm) -> info | lines with parties below (md) -> 3 columns (lg).
export const useStyles = makeStyles((theme: any) => ({
  container: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(3),
    padding: theme.spacing(3),
    [theme.breakpoints.down('sm')]: {
      gap: theme.spacing(2),
      padding: theme.spacing(2),
    },
  },
  actions: {
    display: 'flex',
    justifyContent: 'flex-end',
    gap: theme.spacing(1.25),
    '@media (hover: none) and (pointer: coarse)': {
      '& .MuiButton-root': { minHeight: theme.spacing(5.5) },
    },
  },
  sections: {
    display: 'grid',
    gridTemplateColumns: 'minmax(0, 1fr)',
    gridTemplateAreas: '"info" "lines" "parties"',
    gap: theme.spacing(3),
    [theme.breakpoints.up('md')]: {
      gridTemplateColumns: 'repeat(2, minmax(0, 1fr))',
      gridTemplateAreas: '"info lines" "parties parties"',
    },
    [theme.breakpoints.up('lg')]: {
      gridTemplateColumns: 'repeat(3, minmax(0, 1fr))',
      gridTemplateAreas: '"info lines parties"',
    },
  },
  infoArea: { gridArea: 'info', minWidth: 0 },
  linesArea: { gridArea: 'lines', minWidth: 0 },
  partiesArea: { gridArea: 'parties', minWidth: 0 },
}));
